import { atom } from "jotai";
// import { atomWithStorage } from 'jotai/utils';

export const authUserOriginAtom = atom();
export const authUserDetailsAtom = atom();
export const areUserInformationsCompletedAtom = atom();
